import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Basket } from '@models/basket';
import { Dossier, Suggestion } from '@wizbii/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BasketWebservice {
  fibiiUrl = environment.api.fibii;

  constructor(private readonly httpClient: HttpClient) {}

  createBasket(articles: { suggestionId: string }[]): Observable<Basket> {
    return this.httpClient.post<Basket>(`${this.fibiiUrl}/baskets`, {
      articles,
    });
  }

  addArticleToBasket(suggestionId: string): Observable<Suggestion> {
    return this.httpClient.put<Suggestion>(`${this.fibiiUrl}/baskets/articles`, { suggestionId });
  }

  removeArticleFromBasket(suggestionId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.fibiiUrl}/baskets/articles/${suggestionId}`);
  }

  clearBasket(): Observable<void> {
    return this.httpClient.delete<void>(`${this.fibiiUrl}/baskets/articles`);
  }

  getBasket(): Observable<Basket> {
    return this.httpClient.get<Basket>(`${this.fibiiUrl}/baskets`);
  }

  getDossiers(): Observable<Dossier[]> {
    return this.httpClient.get<Dossier[]>(`${this.fibiiUrl}/dossiers`);
  }

  validateDepotInformations(userId: string, suggestionId: string): Observable<Dossier> {
    return this.httpClient.patch<Dossier>(`${this.fibiiUrl}/dossiers/${userId}/mandate/${suggestionId}`, {});
  }

  createDossier(suggestionId: string): Observable<void> {
    return this.httpClient.post<void>(`${this.fibiiUrl}/dossiers`, { suggestionId });
  }

  updateDossierParameters(
    userId: string,
    suggestionId: string | null,
    body: {
      variant?: string;
      optin?: boolean;
    }
  ): Observable<void> {
    return this.httpClient.patch<void>(
      `${this.fibiiUrl}/dossier/${userId}/suggestion/${suggestionId}/parameters`,
      body
    );
  }
}
